import { cn } from "@/lib/utils";

export const floatingFieldShellClassName =
  "relative flex w-full self-start items-center rounded-md border border-input bg-background shadow-xs transition-[color,box-shadow] focus-within:border-ring focus-within:ring-ring focus-within:ring-1 focus-within:ring-inset focus-within:shadow-none has-[[aria-invalid=true]]:border-destructive has-[[aria-invalid=true]]:ring-destructive/20 dark:has-[[aria-invalid=true]]:ring-destructive/40";

export const floatingFieldControlClassName =
  "h-9 w-full border-0 bg-transparent px-3 text-sm shadow-none outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50";

export const floatingFieldLabelClassName = (
  active: boolean,
  align: "center" | "top" = "center",
) =>
  cn(
    "pointer-events-none absolute left-2.5 z-10 origin-left px-1 transition-[top,transform,font-size,color,background-color] duration-150 ease-out",
    active
      ? "-top-2 translate-y-0 bg-background text-2xs font-medium leading-none text-muted-foreground"
      : align === "top"
        ? "top-2.5 translate-y-0 bg-transparent text-sm text-muted-foreground"
        : "top-1/2 -translate-y-1/2 bg-transparent text-sm text-muted-foreground",
  );

/** Placeholder only while floating label is raised (focused or filled). */
export const floatingFieldPlaceholder = (
  active: boolean,
  placeholder?: string,
) =>
  active ? (placeholder && placeholder.trim() ? placeholder : undefined) : " ";

/**
 * Hide native date/datetime format ghost text (mm/dd/yyyy) while the floating
 * label is sitting inside an empty field.
 */
export const floatingDateEmptyValueClassName = (active: boolean) =>
  active
    ? undefined
    : "[&::-webkit-datetime-edit]:text-transparent [&::-webkit-datetime-edit-fields-wrapper]:text-transparent [&::-webkit-datetime-edit-text]:text-transparent [&::-webkit-datetime-edit-month-field]:text-transparent [&::-webkit-datetime-edit-day-field]:text-transparent [&::-webkit-datetime-edit-year-field]:text-transparent [&::-webkit-datetime-edit-hour-field]:text-transparent [&::-webkit-datetime-edit-minute-field]:text-transparent [&::-webkit-datetime-edit-ampm-field]:text-transparent";

export const isFloatingFieldActive = (focused: boolean, value: unknown) =>
  focused || String(value ?? "").length > 0;
